module.exports = __webpack_public_path__ + "static/media/icon-paper.ac2bb2bf.png";